import { gql } from '@apollo/client'

export const customerUserErrorFragment = gql`
  fragment CustomerUserErrorFragment on CustomerUserError {
    code
    field
    message
  }
`
